/**
*   Closed Captioner
*/
(function($) {

    // Nest inside function
    const _public = (function() {

        let _options = {};
        const _private = {};
        const _defaults = {

            // in milliseconds
            time: 0,

            // json object
            data: null,

            // adds captions to dom
            render($el, sectionData) {
                if (!sectionData) {
                    $el.html("");
                } else {
                    $el.html(`<p class='cc-caption'>${  sectionData.text  }</p>`);
                }

            }
        };

        /**
		*   Section is one of the individual json objects
		*   when it is set, we use the beginTime and endTime on the object
		*   to determine display.  When null, we search for the next one.
		*/
        _private.section = null;
        _private.sectionChange = 0;
        _private.$el = null;

        /**
		*   Reset defaults
		*/
        _private.reset = function() {
            _options = null;
            _options = {};
            _private.section = null;
            _private.$el = null;
        };

        /**
		*   Check current caption time
		*/
        _private.checkTime = function() {
            if (!_private.section || (_options.time < _private.section.begin_time || _options.time >= _private.section.end_time) ) {
                // Need to find the next section if there is one
                _private.section = _private.getSection();
                _private.sectionChange = 1;
            } else if (_options.time >= _private.section.begin_time && _options.time < _private.section.end_time) {
                // if time is in section, then nothing has changed
                _private.sectionChange = 0;
            }

            _private.render();
        };

        /**
		*   Determine whether to render caption or not
		*   based on sectionChange
		*/
        _private.render = function() {
            if (_private.sectionChange !== 1) {
                return;
            }
            _private.sectionChange = 0;
            _options.render(_private.$el, _private.section);
        };

        /**
		*   Get current caption section
		*/
        _private.getSection = function() {
            for (let i = 0; i < _options.data.length; i += 1) {
                if (_options.time >= _options.data[i].begin_time && _options.time < _options.data[i].end_time) {
                    return _options.data[i];
                }
            }

            return null;
        };

        /**
		*   Public functions available through the jquery object
		*/
        return {

            /**
			*   Main initialization
			*/
            init(options) {

                _private.reset();

                // set element
                _private.$el = $(this);

                // extend defaults with options
                _options = {};
                $.extend(_options, _defaults, options);

                // Do some data checks
                if (!_options.data || typeof _options.data !== "object" || _options.data.length === 0) {
                    $.error("init : data : caption data is required");

                    return false;
                }

                _private.checkTime();
            },

            /**
			*   Update time in milliseconds
			*/
            updateTime(ms) {
                _options.time = ms;
                _private.checkTime();
            }
        };

    }());

    /**
	*   Closed Captioner registration on jquery object
	*       - only routes options to closure methods above
	*/
    $.fn.closedCaptioner = function (methodOrOptions) {
        if (_public[methodOrOptions]) {
            return _public[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return _public.init.apply(this, arguments);
        }

        $.error(`Method ${  methodOrOptions  } does not exist on jQuery.closedCaptioner`);

    };
})(jQuery);
